import { USER_TEXT } from '@/config/translation/text'
import BackHeader from '@/layout/components/BackHeader'
import { userLogout } from '@/services'
import { Card, Col, Row } from 'antd'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import UserInfo from './components/UserInfo'
import { UserLanguage } from './components/UserLanguage'
import UserResetPassword from './components/UserResetPassword'
import './UserProfile.style.less'
import { UserOutlined } from '@ant-design/icons'
import Header from '@/layout/components/Header'

function UserProfile() {
  const { t } = useTranslation()

  const [page, setPage] = useState<number>(1)
  const navigate = useNavigate()

  const onLogout = async () => {
    await userLogout()
    navigate('/')
  }

  return (
    <div className="user-profile-page">
      <div className="user-profile-mobile-header-wrapper">
        <Header
          icon={<UserOutlined className="icon" />}
          title=""
          background="linear-gradient(181.35deg, #5B5B5B 1.15%, #848484 98.85%)"
        />
      </div>
      <div className="user-profile-desktop-header">
        <BackHeader title="Go Back" onClick={() => navigate(-1)} />
      </div>
      <Row className="user-profile-container" gutter={[32, 16]}>
        <Col xs={24} md={6}>
          <Card className="card">
            <ul className="profile-nav-list">
              <li>
                <div
                  onClick={() => {
                    setPage(1)
                  }}
                >
                  <strong className={page == 1 ? 'active' : 'inactive'}>
                    {t(USER_TEXT.PROFILE)}
                  </strong>
                  <p>{t(USER_TEXT.PROFILE_INFO)}</p>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    setPage(2)
                  }}
                >
                  <strong className={page == 2 ? 'active' : 'inactive'}>
                    Password
                  </strong>
                  <p>Change user password</p>
                </div>
              </li>
              <li className="profile-nav-logout">
                <div onClick={onLogout}>
                  <strong
                    className={`${
                      page == 1 ? 'active' : 'inactive'
                    } logout-button`}
                  >
                    Logout
                  </strong>
                </div>
              </li>
            </ul>
          </Card>
        </Col>
        <Col xs={24} md={18}>
          <Card className="profile-content-card">
            {page == 1 ? (
              <UserInfo />
            ) : page == 2 ? (
              <UserResetPassword />
            ) : (
              <UserLanguage />
            )}
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default UserProfile
